import React from "react";
import { formatNumber } from "../../utilities/formatNumber";
import { TooltipTrigger } from "../Tooltip/Tooltip";
import { MORTGAGE_TYPE } from "./RateTypes";
import useLanguage from '../../utilities/useLanguage';
import { getTranslation } from "./translations";

function Apr({ apr = -1, lang, initial, decimals }) {
    return (
        <>
            <span className="small-text text-sans">{getTranslation(lang).asLowAs}</span>
            <br />
            {apr === -1
                ? <>{formatNumber(initial, decimals)}<div className="rate-percentage">%<div className="subtext">{getTranslation(lang).apr}</div></div></>
                : <>{formatNumber(initial, decimals)}%<br />({formatNumber(apr, decimals)}<div className="rate-percentage">%<div className="subtext">{getTranslation(lang).apr}</div></div>)</>
            }
        </>
    )
}

function Apy({ apy, lang, decimals }) {
    return (
        <>{formatNumber(apy, decimals)}<div className="rate-percentage">%<div className="subtext">{getTranslation(lang).apy}</div></div></>
    )
}

function RatePercentage({ rate, lang, decimals }) {
    let apr, type = "APY";

    if (rate.apy <= 0) {
        type = "APR";
        if (rate.disclosureInformation) {
            if (rate.disclosureInformation.apr) {
                apr = rate.disclosureInformation.apr;
            }
        }
    }

    return (
        <div className="p-0 px-2 px-md-0 px-xl-3 content position-absolute">
            {type === "APR" ? <Apr apr={apr} lang={lang} initial={rate.initialRate} decimals={decimals} /> : <Apy apy={rate.apy} lang={lang} decimals={decimals} />}
        </div >
    )
}

export default ({ name, rate, dragging, tooltipPlace }) => {
    const { lang } = useLanguage();

    function handleClick(e) {
        if(!dragging) {
            window.location.href = rate.product.callToAction.link;
        }
    }

    return (
        <div onClick={handleClick} className="rate-content d-flex w-100 position-relative bg-white">
            <div className="rate-name col-12 p-0 col-md-7">
                <div className="w-100 h-100 p-0 px-2 px-lg-3 content position-relative d-flex flex-column">
                    <div className="align-items-center d-flex overflow-hidden flex-grow-1">{name}</div>
                    <div className="cta-text mb-2">
                        <a href="#">{getTranslation(lang).learnMore}</a>
                    </div>
                </div>
            </div>
            <div className="rate-info p-0 col-12 col-md-5 text-primary text-serif justify-content-center align-items-center">
                <RatePercentage rate={rate} lang={lang} decimals={Number(rate.product.type) === MORTGAGE_TYPE ? 3 : 2} />
                <TooltipTrigger className="rate-tooltip position-absolute d-lg-block d-block" html={rate.product.disclosure.disclosureData} place={tooltipPlace} />
            </div>
        </div >
    )
}
